import { Controller } from 'stimulus'

export default class extends Controller {
  update() {
    this.element.style.width = `${this.element.value.length + 2}ch`
  }

  autosave() {
    this.element.form.requestSubmit()
    Turbo.clearCache()
  }

  checkReturn(event) {
    if (event.keyCode == 13) {
      this.element.blur()
    }
  }
}
